// modules
import { handleActions } from 'redux-actions'

// actions
import { setCareGiverShiftReport } from 'src/store/modules/reports/caregiversShiftReport'

const initialState = {
  careGiverShiftReport: []
}

export default handleActions(
  {
    [setCareGiverShiftReport](state, { payload: careGiverShiftReport }) {
      return {
        ...state,
        careGiverShiftReport
      }
    }
  },
  initialState
)
